import hljs from 'highlight.js'

const SyntaxHighlighter = {}

SyntaxHighlighter.install = function (Vue, options) {
  Vue.directive('highlight', function (el) {
    const blocks = el.querySelectorAll('pre')
    blocks.forEach((block) => {
      hljs.highlightElement(block)
    })
  })
}

export default SyntaxHighlighter
